import React from 'react'
import Container from '@material-ui/core/Container'
import styleClasses from '../components/common/common.module.scss'
import ConstructionsDetail from '../components/constructions/ConstructionsDetail'

export default function ConstructionDetailPage() {
  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        <ConstructionsDetail />
      </Container>
    </main>
  )
}
